export default {
  overview: 'Resumen',
  today_overview: 'Resumen de hoy',
  balance: 'Saldo',
  in_transit: 'En tránsito',
  abd_balance: 'Monto ADB',
  total_transaction: 'Total de transacciones',
  transaction_count: 'Cantidad de transacciones',
  transaction_amount: 'Monto de transacción',
  transaction_fee: 'Comisión de transacción',
  payin: 'Transacciones de cobro (Pay-in)',
  payout: 'Transacciones de pago (Pay-out)',
  number: 'Cantidad de transacciones',
  amount: 'Monto',
  payin_number: 'Cantidad de cobros',
  payout_number: 'Cantidad de pagos',
  payin_amount: 'Monto cobrado',
  payout_amount: 'Monto pagado',
  transaction_trends: 'Tendencias de transacciones',
  all: 'Total',
  fee: 'Comisión de servicio',
  today: 'Hoy',
  week: 'Últimos 7 días',
  month: 'Últimos 30 días',
  commission: 'Comisión',
  my_assets: 'Mis activos',
  account_balance: 'Saldo de la cuenta',
  balance_exchange_rate_tip: 'Calculado según el tipo de cambio en tiempo real. Prevalecerá el saldo mostrado en la página de retiro.',
  withdraw_now: 'Retirar ahora',
  collapse: 'Contraer',
  expand_more: 'Mostrar más',
  reference_exchange_rate: 'Tipo de cambio de referencia en tiempo real',
  updated_at: 'Actualizado el',
  exchange_rate_disclaimer: 'Este tipo de cambio es solo de referencia. Prevalecerá el tipo aplicado en el momento de la transacción.',
  currency_assets: 'Activos por moneda',
  available: 'Disponible',
  frozen: 'Congelado'
}
